const iso4217 = [
    {countryCode: "KR", currency: "KRW"},
    {countryCode: "US", currency: "USD"},
    {countryCode: "TW", currency: "TWD"},
];

export default iso4217;